import { ReactNode } from "react";

interface TitleBarProps {
  title?: string;
  as?: "h1" | "h2" | "p";
  children?: ReactNode;
}

export default function TitleBar({
  title = "Emergency Vehicle Technician Certification Commission",
  as: Component = "p",
  children,
}: TitleBarProps) {
  return (
    <div className="relative w-full border-b border-black bg-linear-to-b from-white to-gray-300">
      <div className="fluid-container py-2">
        {children || (
          <Component className="text-center font-serif text-fluid-h2 font-bold italic text-black my-0 py-0">
            {title}
          </Component>
        )}
      </div>
    </div>
  );
}